export default {
    AQUISICAO_SEPARADA: 'Aquisição Separada',
    GERACAO_INTERNA: 'Geração interna',
    TRANSACAO_SEM_CONTRAPRESTACAO: 'Transação Sem Contraprestação'
}
